



































import {
  defineComponent, PropType, computed, ref,
} from '@nuxtjs/composition-api';

type SizeType = 'sm' | 'md' | 'lg';

export default defineComponent({
  name: 'ProductLabels',
  props: {
    omnibusPrice: {
      type: [Number, String] as PropType<number | string>,
      default: null,
    },
    isBestseller: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isRecommended: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isNew: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    size: {
      type: String as PropType<SizeType>,
      default: 'md',
    },
  },
  setup(props) {
    const sizes = ref({
      sm: 'py-1 px-2 text-xs',
      md: 'py-0.5 px-2 text-xs',
      lg: 'py-1 px-3 2xl:px-4 2xl:py-2 text-sm',
    });
    const sizeClasses = computed(() => sizes.value[props.size]);
    return { sizeClasses };
  },
});
